
import React from 'react';
import ResourcePageLayout from '@/components/layouts/ResourcePageLayout';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const FAQ = () => {
  const faqItems = [
    {
      question: "What is Hormone Harmony 30 day Coaching Plan?",
      answer: "Hormone Harmony 30 day Coaching Plan is a personalized wellness platform designed to help individuals understand and manage their hormonal health. Through daily lessons, tracking tools, and tailored recommendations, we support your journey to hormonal balance and overall wellbeing."
    },
    {
      question: "How does the Hormone Harmony 30 day Coaching Plan app work?",
      answer: "Our app provides daily lessons on hormone health, allows you to track your mood and symptoms, and offers personalized recommendations based on your data. By logging in daily, you can earn points, unlock badges, and participate in community challenges."
    },
    {
      question: "Is Hormone Harmony 30 day Coaching Plan suitable for all genders?",
      answer: "While our primary focus is on female hormonal health, our content and recommendations can benefit anyone interested in understanding and improving their hormonal wellbeing."
    },
    {
      question: "How do I track my symptoms?",
      answer: "In the daily lessons section, you'll find a symptoms tracker where you can select common symptoms or add custom ones. Your selections are saved to help you identify patterns over time."
    },
    {
      question: "What happens during the onboarding process?",
      answer: "During onboarding, we collect information about your health history, symptoms, and goals. This helps us personalize your experience and provide relevant content and recommendations."
    },
    {
      question: "How is my data protected?",
      answer: "We take data privacy seriously. All your information is encrypted and stored securely. We never share your personal data with third parties without your explicit consent. For more details, please see our Privacy Policy."
    }
  ];

  return (
    <ResourcePageLayout 
      title="Frequently Asked Questions" 
      description="Here are some common questions and answers to help you understand Hormone Harmony 30 day Coaching Plan."
    >
      <Accordion type="single" collapsible className="w-full">
        {faqItems.map((item, index) => (
          <AccordionItem key={index} value={`item-${index}`}>
            <AccordionTrigger className="text-left font-medium text-Hormone Balance Guide-charcoal hover:text-Hormone Balance Guide-coral">
              {item.question}
            </AccordionTrigger>
            <AccordionContent className="text-Hormone Balance Guide-charcoal/80">
              {item.answer}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </ResourcePageLayout>
  );
};

export default FAQ;
